import { Injectable } from "@angular/core";
import * as jspdf from "jspdf";
import html2canvas from "html2canvas";
// import { options } from "preact";
import * as html2pdf from 'html2pdf.js'
import { GenericService } from "../services/generic.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PdfService {
  constructor(
    public genericService:GenericService,
    private http:HttpClient
  ) { }

  baseUrl = environment.baseUrl;

  public checkListReport(model:any){
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.post<any>("https://watchdog.microlent.com/api/pdf/generatepdf", model, httpOptions);
  }
  public getCheckListReporPdf(id:any){
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<any>(`${this.baseUrl}checklists/report/download/${id}`, httpOptions);
  }
  public getCheckListReporForAppPdf(id:any){
    // const httpOptions = {
    //   responseType: 'blob' as 'json'
    // };
    return this.http.get<any>(`${this.baseUrl}checklists/report/downloadForApp/${id}`);
  }
  public getCheckListReport(id:any){
    return this.genericService.Get<any>(`checklists/report/pdf/${id}`);
  }
  // public convertToPdf(id, pdfName) {
  //   var data = document.getElementById(id);
  //   var opt = {
  //     margin: [1, 1, 20, 1],
  //     filename: pdfName+'.pdf',
  //     html2canvas: { dpi: 192, scale: 2, letterRendering: true, useCORS: true },
  //     pagebreak: { mode: 'avoid-all' },
  //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  //   };

  //   // New Promise-based usage:
  //   html2pdf().from(data).set(opt).toPdf().get('pdf').then(function (pdf) {
  //     var totalPages = pdf.internal.getNumberOfPages();
  //     for (let i = 1; i <= totalPages; i++) {
  //       pdf.setPage(i);
  //       pdf.setFontSize(10);
  //       pdf.setTextColor(100);
  //       pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() / 2.3), (pdf.internal.pageSize.getHeight() - 3));

  //     }
  //   }).save();
  // }


  public convertToPdf(id, pdfName) {
    const data = document.getElementById(id);
    const opt = {
      margin: [10, 10, 10, 10], // Top, left, bottom, right (in mm)
      filename: pdfName + '.pdf',
      html2canvas: {
        dpi: 192,
        scale: 2,
        letterRendering: true,
        useCORS: true
      },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'] // better page breaking
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'landscape' // changed from portrait to landscape
      }
    };
  
    html2pdf().from(data).set(opt).toPdf().get('pdf').then(function (pdf) {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          'Page ' + i + ' of ' + totalPages,
          pdf.internal.pageSize.getWidth() / 2.3,
          pdf.internal.pageSize.getHeight() - 5
        );
      }
    }).save();
  }
  
  public convertToPdf1(id, pdfName) {
    var data = document.getElementById(id);
    html2canvas(data).then((canvas) => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL("image/png");
      let pdf = new jspdf.jsPDF("p", "mm", "a4"); // A4 size page of PDF
      pdf.setFontSize(80);
      var position = 0;
      pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save(pdfName + ".pdf"); // Generated PDF
    });
  }

  public printPdf(id, isCert?: boolean) {
    this.test2(id, isCert);
  }

  test2(id, isCert?: boolean) {
    var data = document.getElementById(id);

    html2canvas(data, { useCORS: true, allowTaint: true, scrollY: 0 }).then((canvas) => {
      const image = { type: 'jpeg', quality: 0.98 };
      const margin = [0.5, 0.5];

      var imgWidth = 8.5;
      var pageHeight = 10.2;

      if (id == 'printCertificate' || id == 'GapAnalysisReport') {
        var imgWidth = 11.5;
      }
      var innerPageWidth = imgWidth - margin[0] * 2;
      var innerPageHeight = pageHeight - margin[1] * 2;

      // Calculate the number of pages.
      var pxFullHeight = canvas.height;

      var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
      var nPages = Math.ceil(pxFullHeight / pxPageHeight);

      // Define pageHeight separately so it can be trimmed on the final page.
      var pageHeight = innerPageHeight;


      // Create a one-page canvas to split up the full image.
      var pageCanvas = document.createElement('canvas');
      var pageCtx = pageCanvas.getContext('2d');
      pageCanvas.width = canvas.width;
      pageCanvas.height = pxPageHeight;
      // Initialize the PDF.
      var pdf = new jspdf.jsPDF();
      if (isCert)
        pdf = new jspdf.jsPDF('l', 'in', 'a4');
      else
        pdf = new jspdf.jsPDF('p', 'in', 'a4');

      for (var page = 0; page < nPages; page++) {
        var i = page + 1;

        // Trim the final page to reduce file size.
        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
          pageCanvas.height = pxFullHeight % pxPageHeight;
          pdf.setFontSize(10);
          pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
        }

        // Display the page.
        var w = pageCanvas.width;
        var h = pageCanvas.height;
        pageCtx.fillStyle = 'white';
        pageCtx.fillRect(0, 0, w, h);
        pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

        // Add the page to the PDF.
        if (page > 0) pdf.addPage(); pdf.setFontSize(8);
        pdf.text('Page ' + i + ' of ' + nPages, 4, 10.5);
        var imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
        pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
      }

      pdf.autoPrint();
      window.open(pdf.output("bloburl"));
    })
  }

  // public convertToPdf(id, pdfName) {
  //   var data = document.getElementById(id);
  //   html2canvas(data, { useCORS: true, allowTaint: true, scrollY: 0 }).then((canvas) => {
  //     const image = { type: 'jpeg', quality: 0.98 };
  //     const margin = [0.5, 0.5];
  //     var imgWidth = 8.5;
  //     var pageHeight = 10.2;

  //     var innerPageWidth = imgWidth - margin[0] * 2;
  //     var innerPageHeight = pageHeight - margin[1] * 2;

  //     // Calculate the number of pages.
  //     var pxFullHeight = canvas.height;
  //     var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
  //     var nPages = Math.ceil(pxFullHeight / pxPageHeight);

  //     // Define pageHeight separately so it can be trimmed on the final page.
  //     var pageHeight = innerPageHeight;

  //     // Create a one-page canvas to split up the full image.
  //     var pageCanvas = document.createElement('canvas');
  //     var pageCtx = pageCanvas.getContext('2d');
  //     pageCanvas.width = canvas.width;
  //     pageCanvas.height = pxPageHeight;

  //     // Initialize the PDF.
  //     // var pdf = new jspdf.jsPDF('p', 'in', [8.5, 11]);
  //     var pdf = new jspdf.jsPDF('p', 'in', 'a4');

  //     for (var page = 0; page < nPages; page++) {
  //       var i = page + 1;
  //       // Trim the final page to reduce file size.
  //       if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
  //         pageCanvas.height = pxFullHeight % pxPageHeight;
  //         pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
  //       }

  //       // Display the page.
  //       var w = pageCanvas.width;
  //       var h = pageCanvas.height;
  //       pageCtx.fillStyle = 'white';
  //       pageCtx.fillRect(0, 0, w, h);
  //       pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

  //       // Add the page to the PDF.
  //       if (page > 0) pdf.addPage();
  //       pdf.setFontSize(8);
  //       pdf.text('Page ' + i + ' of ' + nPages, 4, 10.5);
  //       var imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
  //       pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
  //     }

  //     pdf.save(pdfName + ".pdf"); // Generated PDF
  //   })
  // }
  
}
